import React, { PureComponent, Fragment } from 'react';

// import ReactEcharts from "echarts-for-react";
import ReactEcharts from "echarts-for-react";





export default class BiaxialLineChart extends PureComponent {
  constructor(props) {
      super(props);

      this.state = {
        data : this.props.data,
        x : this.props.x,
        y : this.props.y,
      }
    }

    componentWillReceiveProps = (nextProps) => {
        
      this.setState({
        data : nextProps.data,
        x : nextProps.x,
        y : nextProps.y,
      });
    }




  render() {

    const option = {
        xAxis: {type: 'value', name:this.state.x, min : -100, max : 100, interval : 50},
        yAxis: {type: 'value', name:this.state.y, min : -100, max : 100, interval : 50},
        tooltip : {
          formatter : params => {
            console.log(params);
            return params.value[2] + "<br/> " + this.state.x + " : " + params.value[0].toFixed(4) + "<br/> " + this.state.y + " : " + params.value[1].toFixed(4);
          }
        },
        legend: {
            show : false    
        },
        series: [{
            symbolSize: 5,
            name: 'A',
            data: this.state.data.A,
            type: 'scatter',
            markArea: {
                silent: true,
                itemStyle: {
                    color: 'transparent',
                    borderWidth: 0                    
                },
                label : {
                  position : 'insideTopRight',
                  fontSize : 20
                },
                data: [[{
                    name: 'A',
                    xAxis: 'min',
                    yAxis: 'min'
                }, {
                    xAxis: 'max',
                    yAxis: 'max'
                }]]
            }
        },
        {
            symbolSize: 5,
            name: 'B',
            data: this.state.data.B,
            type: 'scatter',
            markArea: {
                silent: true,
                itemStyle: {
                    color: 'transparent',
                    borderWidth: 0                    
                },
                label : {
                  position : 'insideBottomRight',
                  fontSize : 20
                },
                data: [[{
                    name: 'B',
                    xAxis: 'min',
                    yAxis: 'min'
                }, {
                    xAxis: 'max',
                    yAxis: 'max'
                }]]
            }
        },
        {
            symbolSize: 5,
            name: 'C',
            data: this.state.data.C,
            type: 'scatter',
            markArea: {
                silent: true,
                itemStyle: {
                    color: 'transparent',
                    borderWidth: 0                    
                },
                label : {
                  position : 'insideTopLeft',
                  fontSize : 20
                },
                data: [[{
                    name: 'C',
                    xAxis: 'min',
                    yAxis: 'min'
                }, {
                    xAxis: 'max',
                    yAxis: 'max'
                }]]
            }
        },
        {
            symbolSize: 5,
            name: 'D',
            data: this.state.data.D,
            type: 'scatter',
            markArea: {
                silent: true,
                itemStyle: {
                    color: 'transparent',
                    borderWidth: 0                    
                },
                label : {
                  position : 'insideBottomLeft',
                  fontSize : 20
                },
                data: [[{
                    name: 'D',
                    xAxis: 'min',
                    yAxis: 'min'
                }, {
                    xAxis: 'max',
                    yAxis: 'max'
                }]]
            }
        }
        ]
    };



    return (
      <ReactEcharts theme="macarons" option={option} />
    );
  }
}
